module.exports = __webpack_public_path__ + "static/media/excelFileIcon.cf61cb68.svg";